import React from "react";

const Privacy = () => {
  return (
    <div className="max-w-4xl mx-auto p-6">
      <h1 className="text-2xl font-bold mb-4">Privacy Policy</h1>
      <p className="mb-2">
        We respect your privacy. Your personal data will never be sold or shared
        with third parties without your consent.
      </p>
      <p className="mb-2">
        Information is only collected to improve our services and provide a
        better customer experience.
      </p>
      <p className="mb-2">
        For detailed questions, feel free to reach out via our contact page.
      </p>
    </div>
  );
};

export default Privacy;